export const XMLNS = "http://www.w3.org/2000/svg";
export const XLINKS = "http://www.w3.org/1999/xlink";
